import { render } from "./BillDetail.vue?vue&type=template&id=614f75da"
import script from "./BillDetail.vue?vue&type=script&lang=js"
export * from "./BillDetail.vue?vue&type=script&lang=js"

import "./BillDetail.vue?vue&type=style&index=0&id=614f75da&lang=css"

import exportComponent from "/data/deploy/code/save-ocr-ionic/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__